import connectRange from 'instantsearch.js/es/connectors/range/connectRange'
import customRangeInputRenderer from './renderer'

export default function customRefinementList (params) {
  const { render, dispose } = customRangeInputRenderer(params)
  const createWidget = connectRange(render, dispose)

  return { ...createWidget(params), $$widgetType: 'cocoli.rangeInput' }
}
